import React, { useState, useEffect } from "react";
import "./TenantWelcomeBanner.scss";

// Import existing React Icons used in the project
import { RxDashboard } from "react-icons/rx";
import {
  MdPayment,
  MdCreditScore,
  MdOutlineTipsAndUpdates,
} from "react-icons/md";
import { FaHome, FaBus } from "react-icons/fa";

const TenantWelcomeBanner = ({ userName, onStartTour, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add a small delay for smooth animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleStartTour = () => {
    setIsVisible(false);
    setTimeout(() => {
      onStartTour();
    }, 300);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => {
      onDismiss();
    }, 300);
  };

  return (
    <div className={`tenant-welcome-banner ${isVisible ? "visible" : ""}`}>
      <div className="welcome-banner-content">
        <div className="welcome-header">
          <div className="welcome-icon">
            <FaHome style={{ fontSize: "48px", color: "#B39359" }} />
          </div>
          <div className="welcome-text">
            <h2>Welcome to your Dashboard, {userName}!</h2>
            <p>
              We've prepared a quick tour to help you get familiar with your
              payment dashboard and all its features.
            </p>
          </div>
        </div>

        <div className="welcome-features">
          <div className="feature-item">
            <span className="feature-icon">
              <RxDashboard style={{ fontSize: "20px", color: "#192A3A" }} />
            </span>
            <span>View payment reports and progress</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">
              <MdPayment style={{ fontSize: "20px", color: "#192A3A" }} />
            </span>
            <span>Make quick payments from overview</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">
              <MdCreditScore style={{ fontSize: "20px", color: "#192A3A" }} />
            </span>
            <span>Track payment progress visually</span>
          </div>
        </div>

        <div className="welcome-actions">
          <button
            className="tour-btn tour-btn-primary"
            onClick={handleStartTour}
          >
            <span className="btn-icon">
              <FaBus style={{ fontSize: "18px" }} />
            </span>
            Start Tour
          </button>
          <button
            className="tour-btn tour-btn-secondary"
            onClick={handleDismiss}
          >
            Skip for now
          </button>
        </div>

        <div className="welcome-note">
          <small>
            <MdOutlineTipsAndUpdates
              style={{ fontSize: "14px", marginRight: "4px" }}
            />
            You can always access the tour later from the help menu
          </small>
        </div>
      </div>
    </div>
  );
};

export default TenantWelcomeBanner;
